import { render, staticRenderFns } from "./ItemSubHeader.vue?vue&type=template&id=ad635e36"
import script from "./ItemSubHeader.vue?vue&type=script&lang=js"
export * from "./ItemSubHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports